<div class="chat-message-container" fxLayoutGap="4px" [style]="customStyle?.()">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="8px">
    <mat-icon [svgIcon]="'smart_toy'" color="accent" class="message-icon"></mat-icon>
    <span class="message-author">{{ 'AI Bot' }}</span>
    <span class="message-date">{{ $safeNavigationMigration(source()?.datetime) | dateFormat }}</span>
  </div>
  <div class="message-value">
    <a [href]="$safeNavigationMigration(source()?.url)" target="_blank">{{ source()?.comment }}</a>
  </div>
</div>
